var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.alert.type)?_c('alert',{attrs:{"message":_vm.alert.message,"type":_vm.alert.type,"auto-close":_vm.alert.autoClose,"confirmation-proceed":_vm.alert.confirmationProceed,"confirmation-cancel":_vm.alert.confirmationCancel}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }